import { CmObjectType } from '../cta/CmObjectType.js';

/**
 * Common Media Client Data Object Type
 *
 * @group CMCD
 *
 * @beta
 *
 * @enum
 */
export const CmcdObjectType = CmObjectType as typeof CmObjectType;

/**
 * @beta
 */
export type CmcdObjectType = CmObjectType;
